<!--~
~ Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<h2 mat-dialog-title>Password Reset</h2>
<div mat-dialog-content>
  @if (message !== '') {
    <div class='change-password-alert'>{{message}}</div>
  }
  <dash-gis-change-password-form [username]="username"
    (formSubmit)='changePassword($event)'
  (formCancel)='close()'></dash-gis-change-password-form>
</div>
